import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["navItems"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useEffect } from 'react';
import { clickBaseEvent, viewBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../../shared/rio';
import { CenterLinks, StyledTooltip, CenterLinksUL } from '../../../styles';
import { NavLink, NavDropdownItem, NavDropdownLink, DropDownList, Divider, StyledChevronIcon } from '../../../styles.retrofit';

var getNavItemsToRender = function getNavItemsToRender(items, restProps) {
  var envUrl = restProps.envUrl,
      activeItem = restProps.activeItem;
  return items.map(function (item, index) {
    var hasMenuItems = ('menuItems' in item);
    var navMenuItem = item;
    return /*#__PURE__*/React.createElement("li", {
      key: item.text,
      "data-test": "header-desktop-nav-item-".concat(index),
      onMouseEnter: function onMouseEnter() {
        if (hasMenuItems) {
          rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
            data: {
              component_view: {
                state: 'expanded',
                component: {
                  name: 'nav menu',
                  type: 'drop down',
                  region_name: "top nav|".concat(item.text.toLowerCase().trim()),
                  text: navMenuItem.menuItems.map(function (m) {
                    return m.text.trim();
                  }).join('|').toLowerCase()
                }
              }
            }
          }));
        }
      }
    }, hasMenuItems ? /*#__PURE__*/React.createElement(StyledTooltip, {
      position: "bottom",
      targetElement: /*#__PURE__*/React.createElement(NavDropdownItem, {
        isActive: navMenuItem.text === activeItem,
        tabIndex: 0
      }, navMenuItem.text, /*#__PURE__*/React.createElement(StyledChevronIcon, {
        pointing: "down",
        size: "xsmall"
      })),
      "data-test": "header-desktop-nav-item-".concat(index, "-dropdown")
    }, /*#__PURE__*/React.createElement(DropDownList, {
      "data-test": "header-desktop-nav-item-".concat(index, "-dropdownlist")
    }, navMenuItem.menuItems.map(function (menuItem, menuItemIndex) {
      return /*#__PURE__*/React.createElement(NavDropdownLink, {
        key: menuItem.text,
        href: "".concat(envUrl).concat(menuItem.href),
        "data-test": "header-desktop-nav-item-".concat(index, "-listitem-").concat(menuItemIndex),
        onClick: function onClick() {
          var text = menuItem.text;
          var value = text.toLowerCase().trim();
          rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
            data: {
              interaction: {
                type: 'select',
                element: {
                  text: text,
                  type: 'link',
                  name: 'nav menu item',
                  value: menuItem.courseUuid || value,
                  region_name: "top nav|".concat(item.text.toLowerCase().trim())
                }
              }
            }
          }));
        }
      }, menuItem.text);
    }))) : /*#__PURE__*/React.createElement(NavLink, {
      "data-test": "header-desktop-top-nav-".concat(index),
      href: "".concat(envUrl).concat(item.href),
      isActive: item.text === activeItem,
      onClick: function onClick() {
        var text = item.text;
        var value = text.toLowerCase();
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'select',
              element: {
                text: text,
                value: value,
                type: 'link',
                name: 'nav shortcut',
                region_name: 'top nav'
              }
            }
          }
        }));
      }
    }, item.text));
  });
};

var DesktopCenterNav = function DesktopCenterNav(_ref) {
  var navItems = _ref.navItems,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var items = navItems.items,
      subItems = navItems.subItems; // send logs on mount

  useEffect(function () {
    rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
      data: {
        component_view: {
          component: {
            name: 'nav bar',
            type: 'component',
            region_name: 'top nav',
            text: items.map(function (m) {
              return m.text.toLowerCase().trim();
            }).join('|')
          }
        }
      }
    }));
  }, []);
  return /*#__PURE__*/React.createElement(CenterLinks, {
    role: "navigation",
    "aria-label": "main",
    "data-test": "header-desktop-navigation"
  }, /*#__PURE__*/React.createElement(CenterLinksUL, {
    "data-test": "header-desktop-nav-items-list"
  }, getNavItemsToRender(items, restProps), subItems && subItems.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    "data-test": "header-desktop-nav-items-divider"
  }), getNavItemsToRender(subItems, restProps))));
};

DesktopCenterNav.displayName = 'DesktopCenterNav';
export default DesktopCenterNav;